<template>
  <content-panel>
    <template v-slot:search>
      <search-box class="search-box">
        <el-form :model="searchForm" :inline="true" size="mini" ref="searchForm" label-width="100px">
          <el-form-item label="质检人">
            <el-select
              v-model="searchForm.checkPersonList"
              placeholder="请选择"
              filterable
              multiple
              collapse-tags
              @change="checkPersonChange"
            >
              <el-option label="全部" value="" v-show="!all"></el-option>
              <el-option v-if="all" label="取消所有" value="cancleAll"></el-option>
              <el-option v-for="item in checkPersonList" :key="item" :label="item" :value="item"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="店铺简称">
            <el-select v-model="searchForm.storeName" placeholder="请选择" clearable @change="onSearch">
              <el-option label="全部" value=""></el-option>
              <el-option v-for="item in storeList" :key="item" :label="item" :value="item"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="登记日期">
            <form-date-range
              :form="searchForm"
              startKey="registerDateStart"
              endKey="registerDateEnd"
              :usingTime="false"
              valueFormat="yyyyMMdd"
            ></form-date-range>
          </el-form-item>
          <el-form-item label="初审意见">
            <el-select v-model="searchForm.firstReviewOpinions" placeholder="请选择" clearable @change="onSearch">
              <el-option label="全部" value=""></el-option>
              <el-option v-for="item in ['合格', '不合格']" :key="item" :label="item" :value="item"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="复审意见">
            <el-select v-model="searchForm.secondReviewOpinions" placeholder="请选择" clearable @change="onSearch">
              <el-option label="全部" value=""></el-option>
              <el-option v-for="item in ['合格', '不合格']" :key="item" :label="item" :value="item"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="全称客服ID">
            <el-select
              v-model="searchForm.serviceUserIdFullList"
              placeholder="请选择"
              filterable
              multiple
              collapse-tags
              @change="serviceUserIdFullChange"
            >
              <el-option label="全部" value="" v-show="!all2"></el-option>
              <el-option v-if="all2" label="取消所有" value="cancleAll"></el-option>
              <el-option v-for="item in serviceUserIdFullList" :key="item" :label="item" :value="item"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="真实姓名">
            <el-select
              v-model="searchForm.serviceUserNameList"
              placeholder="请选择"
              filterable
              multiple
              collapse-tags
              @change="serviceUserNameChange"
            >
              <el-option label="全部" value="" v-show="!all3"></el-option>
              <el-option v-if="all3" label="取消所有" value="cancleAll"></el-option>
              <el-option v-for="item in serviceUserNameList" :key="item" :label="item" :value="item"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="岗位">
            <el-select v-model="searchForm.serviceUserJob" placeholder="请选择" filterable clearable @change="onSearch">
              <el-option label="全部" value=""></el-option>
              <el-option v-for="item in serviceUserJobList" :key="item" :label="item" :value="item"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="员工编号">
            <el-input v-model="searchForm.serviceUserWorkNoList" @keyup.enter.native="onSearch"></el-input>
          </el-form-item>
          <el-form-item label="责任部门">
            <el-select v-model="searchForm.responsibleDepartment" placeholder="请选择" filterable clearable @change="onSearch">
              <el-option label="全部" value=""></el-option>
              <el-option v-for="item in responsibleDepartmentList" :key="item" :label="item" :value="item"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="客服等级">
            <el-select
              v-model="searchForm.customerServiceLevelList"
              placeholder="请选择"
              filterable
              multiple
              collapse-tags
              @change="customerServiceLevelChange"
            >
              <el-option label="全部" value="" v-show="!all4"></el-option>
              <el-option v-if="all4" label="取消所有" value="cancleAll"></el-option>
              <el-option v-for="item in customerServiceLevelList" :key="item" :label="item" :value="item"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="入职时间">
            <form-date-range
              :form="searchForm"
              startKey="employDateQueryStart"
              endKey="employDateQueryEnd"
              :usingTime="false"
              valueFormat="yyyyMMdd"
            ></form-date-range>
          </el-form-item>
          <el-form-item label="是否申诉">
            <el-select v-model="searchForm.appealFlag" placeholder="请选择" clearable @change="onSearch">
              <el-option label="全部" value=""></el-option>
              <el-option v-for="item in ['是', '否']" :key="item" :label="item" :value="item"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <template v-slot:right>
          <el-button type="primary" size="mini" @click="onSearch">搜索</el-button>
          <el-button class="orange-btn" size="mini" @click="reset">重置</el-button>
        </template>
      </search-box>
    </template>
    <table-panel ref="tablePanel">
      <template v-slot:header-right>
        <el-button type="primary" size="small" @click="tableVisible = true">表格设置</el-button>
        <el-button type="primary" size="small" @click="isShowExport = true">导出</el-button>
      </template>
      <el-table
        :data="tableData.records"
        ref="tableRef"
        border
        :height="maxTableHeight"
        @sort-change="handleSortChange"
        v-loading="loading"
      >
        <el-table-column
          v-for="(item, index) in columnData"
          :key="index"
          :sortable="item.sortable ? 'custom' : false"
          show-overflow-tooltip
          :label="item.displayName"
          :fixed="item.freezeType"
          :prop="item.columnName"
          :min-width="item.displayWidth"
        >
          <template slot-scope="scope">
            <template v-if="item.columnName === 'screenshot'">
              <el-button v-if="scope.row.screenshot" type="text" @click="viewImg(scope.row)">查看</el-button>
            </template>
            <template v-else-if="item.columnName === 'appealReason'">
              <el-button v-if="scope.row.appealReason" type="text" @click="appealReasonImg(scope.row.appealReason)">查看</el-button>
            </template>
            <template v-else>
              {{ scope.row[item.columnName] }}
            </template>
          </template>
        </el-table-column>
      </el-table>
      <template v-slot:footer>
        <div style="text-align: right">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tableData.pageNum"
            :page-sizes="pageSizeList"
            :page-size="tableData.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="tableData.total"
            background
          >
          </el-pagination>
        </div>
      </template>
    </table-panel>
    <appeal-Review :visible.sync="isShowAppealReview" v-if="isShowAppealReview" :appealReason="appealReason"/>
    <export-dialog :visible.sync="isShowExport" v-if="isShowExport" :rowData="rowData" @export="exportExcel" />
    <custom-table
      v-model="tableVisible"
      :tableDataSet="tableDataSet"
      v-if="tableVisible"
      @closeAddForm="closeAddForm"
      @confirm="confirm"
    ></custom-table>
    <!-- 查看图片弹窗 -->
    <el-dialog title="图片查看" :visible.sync="imgFormVisible" :close-on-click-modal="false" width="50%" v-esc-close
      ><imgShow :imgList="imgList"></imgShow
    ></el-dialog>
  </content-panel>
</template>

<script>
import axios from "@/utils/axiosInstance";
import exportDialog from "../components/export";
import imgShow from "@/views/components/imgShow";
import appealReview from "../components/appealReview";
import tableMixin from "@/utils/tableMixin";
import customPropsMixin from "./customProps.mixin";
import moment from "moment";
import pagePathMixin from '@/utils/page-path-mixin'

export default {
  name: 'QualityInspectionSummary',
  mixins: [tableMixin, customPropsMixin, pagePathMixin],
  components: { exportDialog, imgShow, appealReview },
  data() {
    return {
      searchForm: {
        storeName: "",
        firstReviewOpinions: "",
        serviceUserIdFull: "",
        serviceUserName: "",
        serviceUserJob: "",
        responsibleDepartment: "",
        customerServiceLevel: "",
        appealFlag: "",
        registerDateStart: moment(new Date()).subtract(1, "months").format("YYYYMMDD"),
        registerDateEnd: moment(new Date()).format("YYYYMMDD"),
        employDateQueryStart: "",
        employDateQueryEnd: "",
        secondReviewOpinions: "",
      },
      tableHeight: 0,
      tableData: {
        records: [],
        pageNum: 1,
        pageSize: 30,
        total: 0,
      },
      all: false,
      all2: false,
      all3: false,
      all4: false,
      isShowExport: false,
      isShowAppealReview: false,
      rowData: {},
      loading: false,
      tableVisible: false,
      searchFormData: {},
      orderDto: {},
      imgFormVisible: false,
      imgList: [],
      pageSizeList: [30, 60, 90],
      currencyForm: {
        pageSize: 999999,
        pageNum: 1,
        reportCode: "",
        param: {},
        queryMatch: [
          // {
          //   attributeName: '',
          //   val: {},
          //   op: ''
          // }
        ],
        orderList: [
          // {
          //   attributeName: '',
          //   type: ''
          // }
        ],
        orderType: "",
        hasCount: "N",
        groupAttr: "",
      },
      storeList: [],
      //店铺下拉弹窗内
      storeListDialog: [],
      //质检人
      checkPersonList: [],
      //列表店铺
      storeList: [],
      //全称客服ID
      serviceUserIdFullList: [],
      //真实姓名
      serviceUserNameList: [],
      //岗位
      serviceUserJobList: [],
      //责任部门
      responsibleDepartmentList: [],
      //客服等级
      customerServiceLevelList: [],
      appealReason: ''
    };
  },
  computed: {},
  async mounted() {
    await this.getcheckPersonList();
    await this.getstoreList();
    await this.getserviceUserIdFullList();
    await this.getserviceUserNameList();
    await this.getserviceUserJobList();
    await this.getresponsibleDepartmentList();
    await this.getcustomerServiceLevelList();
    await this.initSelct();
  },
  methods: {
    onSearch() {
      this.$refs.tableRef.clearSort();
      this.tableData.pageNum = 1;
      this.init();
    },
    async init(type) {
      this.loading = true;
      let serviceUserWorkNoList = this.searchForm.serviceUserWorkNoList;
      let data = {
        ...this.searchForm,
        pageSize: this.tableData.pageSize,
        pageNum: this.tableData.pageNum,
        serviceUserWorkNoList: serviceUserWorkNoList ? serviceUserWorkNoList.split(" ") : [],
        ...this.orderDto,
      };
      this.searchFormData = data;
      this.$q.qualityTestingManage
        .summaryInfoSearch({ data: data })
        .then((res) => {
          if (res.code == 200) {
            this.tableData = res.data.dynamicData;
            if (!type) {
              this.pagingColumnData = res.data.titleList;
              this.dynamicCustomColumn();
            }
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    // 分页器 pagesize
    handleSizeChange(val) {
      this.tableData.pageSize = val;
      this.tableData.pageNum = 1;
      this.init();
    },
    // 分页器 pageNum
    handleCurrentChange(val) {
      this.tableData.pageNum = val;
      this.init();
    },
    // 重置
    reset() {
      this.tableData.pageNum = 1;
      this.tableData.pageSize = 30;
      this.searchForm = {
        storeName: "",
        firstReviewOpinions: "",
        serviceUserIdFull: "",
        serviceUserName: "",
        serviceUserJob: "",
        responsibleDepartment: "",
        customerServiceLevel: "",
        appealFlag: "",
        registerDateStart: moment(new Date()).subtract(1, "months").format("YYYYMMDD"),
        registerDateEnd: moment(new Date()).format("YYYYMMDD"),
        employDateQueryStart: "",
        employDateQueryEnd: "",
        secondReviewOpinions: "",
      };
      this.initSelct();
      this.onSearch();
    },
    handleSortChange({ column, prop, order }) {
      let type = order === "ascending" ? "0" : order === "descending" ? "1" : false;
      this.tableData.pageNum = 1;
      this.orderDto = {
        sortField: prop,
        sortOptions: order === "ascending" ? "0" : order === "descending" ? "1" : "",
      };
      this.orderDto = type ? this.orderDto : {};
      this.init();
    },
    checkPersonChange(val) {
      this.all = val.length == this.checkPersonList.length ? true : false;
      if (val.includes("")) {
        this.$set(this.searchForm,'checkPersonList',this.checkPersonList)
        this.all = true;
      } else if (val.includes("cancleAll")) {
        this.searchForm.checkPersonList = [];
        this.all = false;
      }
    },
    serviceUserIdFullChange(val) {
      this.all2 = val.length == this.serviceUserIdFullList.length ? true : false;
      if (val.includes("")) {
        this.$set(this.searchForm,'serviceUserIdFullList',this.serviceUserIdFullList)
        this.all2 = true;
      } else if (val.includes("cancleAll")) {
        this.searchForm.serviceUserIdFullList = [];
        this.all2 = false;
      }
    },
    serviceUserNameChange(val) {
      this.all3 = val.length == this.serviceUserNameList.length ? true : false;
      if (val.includes("")) {
        this.$set(this.searchForm,'serviceUserNameList',this.serviceUserNameList)
        this.all3 = true;
      } else if (val.includes("cancleAll")) {
        this.searchForm.serviceUserNameList = [];
        this.all3 = false;
      }
    },
    customerServiceLevelChange(val) {
      this.all4 = val.length == this.customerServiceLevelList.length ? true : false;
      if (val.includes("")) {
        this.$set(this.searchForm,'customerServiceLevelList',this.customerServiceLevelList)
        this.all4 = true;
      } else if (val.includes("cancleAll")) {
        this.searchForm.customerServiceLevelList = [];
        this.all4 = false;
      }
    },
    initSelct() {
      this.checkPersonChange("");
      this.serviceUserIdFullChange("");
      this.serviceUserNameChange("");
      this.customerServiceLevelChange("");
    },
    // 查看图片
    viewImg(row) {
      let imgList = JSON.parse(row.screenshot);
      this.imgFormVisible = true;
      this.imgList = imgList.map((v) => v.filePath);
    },
    // 查看申诉
    appealReasonImg(appealReason) {
      this.isShowAppealReview = true
      this.appealReason = appealReason
    },
    // 导出
    exportExcel(val) {
      let _this = this;
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      let data = {
        ...this.searchFormData,
        exportPhoto: val,
      };
      this.$q.qualityTestingManage.summaryInfoExport({ data: data }).then((res) => {
        console.log(res);
        var timer = setInterval(function () {
          _this.$q.common
            .reportTaskInfo({ fragment: [res.data] })
            .then((res) => {
              if (res.data.taskStatus == "执行完成") {
                clearInterval(timer);
                loading.close();
                _this.isShowExport = false;
                let filePath = JSON.parse(res.data.filePath);
                filePath.forEach((data,index) => {
                  setTimeout(() => {
                    _this.downloadRes(data.filePath, data.fileName);
                  }, index * 200);
                });
              }
            })
            .catch((err) => {
              console.log(err);
              this.$message.error(err.message);
            });
        }, 5000);
      });
    },
    async downloadRes(url, fileName) {
      let response = await fetch(url, { mode: "cors" });
      let blob = await response.blob();
      let objectUrl = window.URL.createObjectURL(blob);
      let a = document.createElement("a");
      a.href = objectUrl;
      a.download = fileName + "" + url.substring(url.lastIndexOf("."));
      a.click();
      a.remove();
    },

    //质检人
    getcheckPersonList() {
      let data = JSON.parse(JSON.stringify(this.currencyForm));
      data.groupAttr = "checkPerson";
      data.reportCode = "QualityCheckPreliminaryReview";
      return this.$q.common.reportsDataGroup({ data: data }).then((res) => {
        let data = Object.keys(res.data.data).map((v) => {
          return v;
        });
        this.checkPersonList = data.filter((v) => v != "(空白)");
      });
    },
    //店铺简称
    getstoreList() {
      let data = JSON.parse(JSON.stringify(this.currencyForm));
      data.groupAttr = "storeName";
      data.reportCode = "QualityCheckPreliminaryReview";
      return this.$q.common.reportsDataGroup({ data: data }).then((res) => {
        let data = Object.keys(res.data.data).map((v) => {
          return v;
        });
        this.storeList = data.filter((v) => v != "(空白)");
      });
    },

    //全称客服ID
    getserviceUserIdFullList() {
      let data = JSON.parse(JSON.stringify(this.currencyForm));
      data.groupAttr = "serviceUserIdFull";
      data.reportCode = "QualityCheckPreliminaryReview";
      return this.$q.common.reportsDataGroup({ data: data }).then((res) => {
        let data = Object.keys(res.data.data).map((v) => {
          return v;
        });
        this.serviceUserIdFullList = data.filter((v) => v != "(空白)");
      });
    },
    //真实姓名
    getserviceUserNameList() {
      let data = JSON.parse(JSON.stringify(this.currencyForm));
      data.groupAttr = "serviceUserName";
      data.reportCode = "QualityCheckPreliminaryReview";
      return this.$q.common.reportsDataGroup({ data: data }).then((res) => {
        let data = Object.keys(res.data.data).map((v) => {
          return v;
        });
        this.serviceUserNameList = data.filter((v) => v != "(空白)");
      });
    },
    //岗位
    getserviceUserJobList() {
      let data = JSON.parse(JSON.stringify(this.currencyForm));
      data.groupAttr = "serviceUserJob";
      data.reportCode = "QualityCheckPreliminaryReview";
      return this.$q.common.reportsDataGroup({ data: data }).then((res) => {
        let data = Object.keys(res.data.data).map((v) => {
          return v;
        });
        this.serviceUserJobList = data.filter((v) => v != "(空白)");
      });
    },
    //责任部门
    getresponsibleDepartmentList() {
      let data = JSON.parse(JSON.stringify(this.currencyForm));
      data.groupAttr = "responsibleDepartment";
      data.reportCode = "QualityCheckPreliminaryReview";
      return this.$q.common.reportsDataGroup({ data: data }).then((res) => {
        let data = Object.keys(res.data.data).map((v) => {
          return v;
        });
        this.responsibleDepartmentList = data.filter((v) => v != "(空白)");
      });
    },
    //客服等级
    getcustomerServiceLevelList() {
      let data = JSON.parse(JSON.stringify(this.currencyForm));
      data.groupAttr = "customerServiceLevel";
      data.reportCode = "QualityCheckPreliminaryReview";
      return this.$q.common.reportsDataGroup({ data: data }).then((res) => {
        let data = Object.keys(res.data.data).map((v) => {
          return v;
        });
        this.customerServiceLevelList = data.filter((v) => v != "(空白)");
      });
    },
  },
};
</script>

<style lang="stylus" scoped>
.search-box
  >>> .el-date-editor.el-input__inner, >>> .el-select, >>> .el-input
      width 240px !important
  >>> .date-range .single-date
    width 110px !important

.panel-in-tab
  >>> .search-outer>div
    padding 0

>>> .el-select__tags-text
  display: inline-block
  max-width: 60px
  overflow: hidden
  text-overflow: ellipsis
  white-space: nowrap

>>> .el-tag__close.el-icon-close
  top: 0px
  right: -4px
</style>
<style lang="css">
.el-tooltip__popper {
  max-width: 40%;
}
</style>
